import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

export const deletePaymentTerm = (condPagId: string): Promise<any> => {
  return axios.delete(`/parameters/cond-pag/${condPagId}`)
}

export function useDeletePaymentTerm() {
  const queryClient = useQueryClient()

  return useMutation(deletePaymentTerm, {
    onSuccess: () => {
      queryClient.invalidateQueries('referencePaymentTerms')
      toast.success(
        'Referência por condição de pagamento excluido com sucesso!'
      )
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error(
        'Não foi possível excluir referência por condição de pagamento!'
      )
    }
  })
}
